import React from "react"
import { Cell } from "fixed-data-table-2"
import { connect } from "react-redux"
import InputCell from "sheets/components/cells/InputCell"
import ErrorCell from "sheets/components/cells/ErrorCell"
import classNames from "classnames"
import PropTypes from "prop-types"
import { statCellConnection } from "sheets/selectors/column-selectors"
import { formatNumber } from "sheets/helper-functions"
import { formatNumberWithCurrencyPrecision } from "shared/imports/sharedHelperFunctions"
import { statCellError } from "sheets/components/helpTexts"
import { checkHasPermission } from "shared/imports/permissionFunctions"

export const StatCell = ({
    barWidth,
    children,
    columnId,
    columnIndex,
    cellIsEditable,
    derived,
    editing,
    isEditable,
    rowId,
    sheetId,
    shouldDisplayAsCurrency,
    shouldRoundCellValue,
    ...props
}) => {
    if (editing && isEditable && cellIsEditable) {
        return (
            <InputCell
                type="number"
                columnId={columnId}
                isResourceTable={props.isResourceTable}
                rowId={rowId}
                sheetId={sheetId}
                width={props.width}
                field={props.field}
            >
                {children}
            </InputCell>
        )
    }
    if (children === null || children === undefined || children === "") {
        return <Cell {...props}>{children}</Cell>
    }

    // if there were errors computing the cell value, display to user reason
    if (Number.isNaN(children) || children === Infinity) {
        return (
            <Cell {...props} style={statCellError.dividyByZero.cellStyles}>
                <ErrorCell tooltipLabel={statCellError.dividyByZero.tooltipText} iconClassName="cell-error-centered" />
            </Cell>
        )
    }

    const isForcedCurrency = checkHasPermission([DjangIO.app.models.PermissionType.qpac_v1]) && shouldDisplayAsCurrency
    return (
        <div className="stat-cell">
            <Cell {...props}>
                <div
                    style={isForcedCurrency ? { "text-align": "right" } : {}}
                    className={isForcedCurrency ? "" : "stat-cell-text"}
                    data-cy={`stat-cell-text-${rowId}`}
                >
                    {isForcedCurrency
                        ? formatNumberWithCurrencyPrecision(Number(children))
                        : formatNumber(Number(children), shouldRoundCellValue)}
                </div>
                {/* hide stat cell scale for Citi */}
                {!isForcedCurrency && Userdata.organization_id !== 3161 && (
                    <svg className={classNames("stat-cell-scale", { derived })}>
                        <rect height="20" width={barWidth} />
                    </svg>
                )}
            </Cell>
        </div>
    )
}

export default connect((state, props) => statCellConnection(state, props), {})(StatCell)

StatCell.propTypes = {
    editing: PropTypes.bool,
    isEditable: PropTypes.bool,
    shouldRoundCellValue: PropTypes.bool.isRequired,
    isRenderingPercent: PropTypes.bool,
    cellIsEditable: PropTypes.bool,
}

StatCell.defaultProps = {
    // keep for backwards compatibility. Eventually should be switched
    // when redoing Sheet.jsx and columnIsEditable
    isEditable: true,
    editing: false,
    isRenderingPercent: false,
    cellIsEditable: true,
}
